import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import R from 'ramda';
import MobileNavigationHorizontalListItem from './MobileNavigationHorizontalListItem';

const MobileNavigationHorizontalList = ({
  page,
  nested,
  navigation,
  showPage,
  goBack,
  goBackDone,
  PageComponent,
  rightChevronIconSrc,
  leftChevronIconSrc,
  disableSwipe,
}) => {
  const className = classNames(
    'mobile-navigation__list',
    'mobile-navigation-horizontal__list', {
      'mobile-navigation__list--nested': nested,
    },
  );

  if (!Array.isArray(page.pages)) {
    return null;
  }

  const pages = R.concat(page.pages, R.propOr([], 'morePages', page));

  return (
    <ul className={className} role="menubar">
      {
        pages.map(nestedPage => (
          <MobileNavigationHorizontalListItem
            key={nestedPage.slug}
            page={{...nestedPage, slug: `${nestedPage.slug}-${page.slug}`}}
            nested={nested}
            navigation={navigation}
            showPage={showPage}
            goBack={goBack}
            goBackDone={goBackDone}
            PageComponent={PageComponent}
            rightChevronIconSrc={rightChevronIconSrc}
            leftChevronIconSrc={leftChevronIconSrc}
            disableSwipe={disableSwipe}
          />
        ))
      }
    </ul>
  );
};

MobileNavigationHorizontalList.propTypes = {
  page: PropTypes.shape({
    pages: PropTypes.array,
    morePages: PropTypes.array,
  }),
  navigation: PropTypes.shape({
    pages: PropTypes.array.isRequired,
    displayedPages: PropTypes.array.isRequired,
  }),
  nested: PropTypes.bool.isRequired,
  showPage: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
  goBackDone: PropTypes.func.isRequired,
  PageComponent: PropTypes.func.isRequired,
  rightChevronIconSrc: PropTypes.string,
  leftChevronIconSrc: PropTypes.string,
  disableSwipe: PropTypes.bool,
};

export default MobileNavigationHorizontalList;
